import { Button, Theme } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import useGustoDisconnectAccount from 'components/domain/integration/gusto/hooks/company/useGustoDisconnectAccount/useGustoDisconnectAccount';
import ConfirmationDialog from 'components/foundation/dialogs/ConfirmationDialog/ConfirmationDialog';
import Well from 'components/foundation/Well/Well';
import { useLoader } from 'contexts/LoaderContext';
import { useOpenable } from 'hooks';
import { t } from 'i18next';
import { ClassName } from 'types/ClassName';

export interface IOrganizationSettingsDetailsProps {
  className?: ClassName;
  onClose: () => void;
}

export default function GustoSettingsDetail({ className, onClose }: IOrganizationSettingsDetailsProps) {
  const confirmationDialog = useOpenable();
  const disconnectGustoAccount = useGustoDisconnectAccount();
  const { open: openLoader, close: closeLoader } = useLoader();

  const classes = classNames('m-6', className);

  return (
    <div className={classes}>
      <Well theme={Theme.DANGER} className={'mb-5'}>
        {t(
          'This will disconnect the user account to Gusto and allow them to reattach. Do not do unless something is wrong with their authentication.'
        )}
      </Well>
      <div className="mt-5">
        <Button onClick={confirmationDialog.open} type="danger" className={'mr-4'}>
          {t('Disconnect Gusto Account')}
        </Button>
        <Button onClick={onClose} type="secondary" className={'mt-4'}>
          {t('Close')}
        </Button>
      </div>
      <ConfirmationDialog
        isOpen={confirmationDialog.isOpen}
        onClose={confirmationDialog.close}
        title={t('Disconnect Gusto Account')}
        message={t('Are you sure you want to disconnect the Gusto account?')}
        confirmButtonText={t('Disconnect')}
        closeButtonText={t('Cancel')}
        onConfirm={async () => {
          openLoader(t('Disconecting...'));
          await disconnectGustoAccount();
          confirmationDialog.close();
          closeLoader();
          onClose();
        }}
      />
    </div>
  );
}
